module.exports = __webpack_public_path__ + "static/media/2.87124f8d.jpg";